import { useApolloClient } from '@vue/apollo-composable'
import { AlgoliaLabels } from '../graphql/queries/queryAlgoliaLabels.graphql'
import type { AlgoliaFilterLabels } from '~/types/algoliaFilterLabels'

export default defineNuxtRouteMiddleware(async () => {
    const { resolveClient } = useApolloClient()
    const client = resolveClient()

    const algoliaFilterLabels = useState<AlgoliaFilterLabels[]>('algoliaFilterLabels')

    const { data } = await client.query({
        query: AlgoliaLabels,
    })

    algoliaFilterLabels.value = data.algolia?.filters
})
